/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import MapDisplay from "../MapDisplay/MapDisplay";

/**
 * SmartMapView component - shows device map with current filters applied
 */
const SmartMapView: React.FC = () => {
  // Always show device map for nodes page
  return <MapDisplay />;
};

export default SmartMapView;
